export const getEmptyCardMessageContainerStyle = () => ({
  height: "100%",
  display: "grid",
  placeItems: "center",
});

export const getEmptyCardMessageContentStyle = () => ({
  display: "flex",
  flexDirection: "column",
  placeItems: "center",
  gap: "16px",
});

export const getEmptyCardMessageTitleStyle = () => ({
  color: "#9e9e9e",
  fontSize: "24px",
  fontWeight: "400",
  fontFamily: "kanit",
});

export const getEmptyCardMessageDescriptionStyle = () => ({
  color: "#9e9e9e",
  fontSize: "16px",
  fontWeight: "300",
  fontFamily: "kanit",
  width: "70%",
  textAlign: "center",
});
